import { DEFAULT_VOCABULARY_TERMS, VocabularyTerms } from '@ftr/contracts/type/core'
import { AbstractBuilder } from '@ftr/foundation'

export class VocabularyTermsBuilder extends AbstractBuilder<VocabularyTerms> {
  constructor() {
    super({
      ...DEFAULT_VOCABULARY_TERMS,
    })
  }
}
